export const getErrorMessage = (code) => {
  return MESSAGES[code];
}

const MESSAGES = {
  'auth/invalid-email': 'Invalid email or password. Please try again.',
  'auth/user-disabled': 'Your account has been disabled. Reach out to an administrator for assistance.',
  'auth/user-not-found': 'No user found with that email. Please try again with a different email or register.',
  'auth/wrong-password': 'Invalid email or password. Please try again.',
  'auth/account-exists-with-different-credential': 'An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.'
};